import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent } from "vue"

const _hoisted_1 = { class: "slider" }
const _hoisted_2 = { class: "slider__step-counter" }
const _hoisted_3 = { class: "slide" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_explanation_animation = _resolveComponent("explanation-animation")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_Transition, {
        name: "slide-up",
        mode: "out-in"
      }, {
        default: _withCtx(() => [
          (_openBlock(), _createElementBlock("div", { key: _ctx.stepText }, _toDisplayString(_ctx.stepText), 1))
        ]),
        _: 1
      })
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_component_explanation_animation, {
        onUpdateStep: _cache[0] || (_cache[0] = (val) => _ctx.stepCounter = val)
      })
    ])
  ]))
}